module.exports = __webpack_public_path__ + "img/Middle_Exhibition_Logo.c9b5d027.jpg";